import { render, staticRenderFns } from "./PlatformLogo.vue?vue&type=template&id=54302125&scoped=true&"
import script from "./PlatformLogo.vue?vue&type=script&lang=js&"
export * from "./PlatformLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54302125",
  null
  
)

export default component.exports